import * as R from 'ramda'
import { t } from 'ttag'
import { getNormalizedScore } from 'utils/score'

const WARM_UP_PAGE = 'warmup'
const COOL_DOWN_PAGE = 'cooldown'

const CREATED = 'CREATED'
const INVITED = 'INVITED'
const IN_PROGRESS = 'IN_PROGRESS'
const SUBMITTED = 'SUBMITTED'

export const ASSESSMENT_GROUP_FIELD = 'evaluators'
export const COMMENT_FIELD = 'comment'
export const SCORE_FIELD = 'score'

export const STATIC_PAGES = [WARM_UP_PAGE, COOL_DOWN_PAGE]

export const SKILL_RANGE = 7

export const getEvaluations = status => ({
  [CREATED]: {
    key: CREATED,
    name: t`Created`,
    isActive: R.equals(status, 1),
    isDone: R.gte(status, 1),
  },
  [INVITED]: {
    key: INVITED,
    name: t`Invited`,
    isActive: R.equals(status, 2),
    isDone: R.gte(status, 2),
  },
  [IN_PROGRESS]: {
    key: IN_PROGRESS,
    name: t`In progress`,
    isActive: R.equals(status, 3),
    isDone: R.gte(status, 3),
  },
  [SUBMITTED]: {
    key: SUBMITTED,
    name: t`Submitted`,
    isActive: R.equals(status, 4),
    isDone: R.gte(status, 4),
  },
})

export const getSkillTitles = R.pipe(
  R.map(({ key, title }) => [key, title]),
  R.fromPairs,
)

export const getDefaultValues = () => ({
  [ASSESSMENT_GROUP_FIELD]: [],
})

export const getValues = ({ assessments }) => ({
  [ASSESSMENT_GROUP_FIELD]: R.pipe(
    R.toPairs,
    R.map(([key, { comment, score }]) => ({
      comment,
      key,
      score: getNormalizedScore(SKILL_RANGE)(score),
    })),
  )(assessments),
})

export const getQuestionComments = ({ assessments } = {}) =>
  R.map(R.propOr({}, 'comments'), assessments ?? {})
